/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_View_Vtp_DetailInputs */

const vi_carrier_view_vtp_detail = /** @type {(inputs: Carrier_View_Vtp_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem chi tiết vận đơn VTP`)
};

/**

* @param {Carrier_View_Vtp_DetailInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_view_vtp_detail = /** @type {((inputs?: Carrier_View_Vtp_DetailInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_View_Vtp_DetailInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_view_vtp_detail(inputs)
});